import { combineReducers } from '@reduxjs/toolkit';
import bigNumbers from './bigNumbers/root';
import contextMenu from './contextMenu';
import datakeys from './datakeys';
import datapoints from './datapoints';
import datapointsCache from './datapointsCache';
import disabledCompetitors from './disabledCompetitors';
import expandedRowKey from './expandedRowKey';
import filters from './filters/filters';
import isLayoutFixed from './isLayoutFixed';
import optimizationSummary from './optimizationPriceEdited';
import offerDataView from './offerDataView';
import pagination from './pagination';
import quickActionsFilters from './quickActionsFilter';
import segmentos from './segmentos';
import selectedDatapoints from './selectedDatapoints';
import sort from './sort';
import totalElements from './totalElements';

const rootReducer = combineReducers({
  quickActionsFilters,
  datapoints,
  datapointsCache,
  totalElements,
  sort,
  contextMenu,
  expandedRowKey,
  filters,
  segmentos,
  selectedDatapoints,
  pagination,
  disabledCompetitors,
  datakeys,
  isLayoutFixed,
  bigNumbers,
  optimizationSummary,
  offerDataView,
});

export type GerenciadorPrecosStateProps = ReturnType<typeof rootReducer>;

export const selectorGerenciadorPrecos = (state: Record<'gerenciadorPrecosReducer', GerenciadorPrecosStateProps>) => state.gerenciadorPrecosReducer;

export default rootReducer;
